import { LOAN_PROGRAM_FIXED_10, LOAN_PROGRAM_FIXED_15, LOAN_PROGRAM_FIXED_20, LOAN_PROGRAM_FIXED_30, LOAN_PROGRAM_ARM_7_1, LOAN_PROGRAM_ARM_5_1, LOAN_PROGRAM_ARM_3_1 } from '@nerdwallet/home-constants';
/**
 * Gets the loan term in months from given loan program
 * @param  {String} loanProgram LOAN_PROGRAM
 * @return {Number}             Loan term in months (or null if given bad program)
 */

export default (function (loanProgram) {
  switch (loanProgram) {
    case LOAN_PROGRAM_FIXED_10:
      return 120;

    case LOAN_PROGRAM_FIXED_15:
      return 180;

    case LOAN_PROGRAM_FIXED_20:
      return 240;

    case LOAN_PROGRAM_FIXED_30:
    case LOAN_PROGRAM_ARM_7_1:
    case LOAN_PROGRAM_ARM_5_1:
    case LOAN_PROGRAM_ARM_3_1:
      return 360;

    default:
      return null;
  }
});